import CertificateComponent from '@app/components/apps/common/Certificate';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Row, Col } from 'antd';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CertificatePage: React.FC = () => {
  const location = useLocation();
  const { id, pr_code, pdfUrl } = location.state || {};

  console.log('Location State:', location.state);

  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Certificate');
  const { setBreadcrumb, clearHeaderButtons, addHeaderButton } = useHeader();

  const isPreClearance = pdfUrl && pdfUrl.includes('pre_clearance');

  const routes = isPreClearance
    ? [
        {
          path: '/pre-clearance',
          breadcrumbName: 'Pre-Clearance',
        },
        {
          path: '/view-pre-clearance',
          breadcrumbName: pr_code || 'View Pre-Clearance',
          state: { id: id },
        },
        {
          path: '/view-certificate',
          breadcrumbName: currentBreadcrumName,
        },
      ]
    : [
        {
          path: '/product-registrations-imp-free-sales',
          breadcrumbName: 'PR - Importer Free Sales',
        },
        {
          path: '/view-product-registrations-imp-free-sales',
          breadcrumbName: pr_code || 'View Product Registration',
          state: { id: id },
        },
        {
          path: '/view-certificate',
          breadcrumbName: currentBreadcrumName,
        },
      ];

  useEffect(() => {
    console.log('Updated Breadcrumb Routes:', routes);

    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    if (!isPreClearance) {
      addHeaderButton(
        'Download PDF',
        <BaseButton type="primary" size="small">
          Download Certificate
        </BaseButton>,
      );
    }

    if (!isPreClearance) {
      addHeaderButton(
        'Register Product',
        <BaseButton type="primary" size="small">
          Make Payment
        </BaseButton>,
      );
    }

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, addHeaderButton, currentBreadcrumName, isPreClearance, pr_code, id]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CertificateComponent id={id} setCurrentBreadcrumName={setCurrentBreadcrumName} pdfUrl={pdfUrl} />
        </Col>
      </Row>
    </>
  );
};

export default CertificatePage;
